function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import throttle from 'lodash.throttle';
import { FileNotFoundError, FileUtils, isFileType } from '@deephaven/file-explorer';
import Log from '@deephaven/log';
import GrpcFileStorageTable from "./GrpcFileStorageTable.js";
var log = Log.module('GrpcFileStorage');
export class GrpcFileStorage {
  /**
   * FileStorage implementation using gRPC
   * @param storageService Storage service to use
   * @param root Root path for this instance. Should not contain trailing slash.
   */
  constructor(dh, storageService) {
    var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "storageService", void 0);
    _defineProperty(this, "tables", []);
    _defineProperty(this, "root", void 0);
    _defineProperty(this, "refreshTables", throttle(() => {
      this.tables.forEach(table => table.refresh());
    }, GrpcFileStorage.REFRESH_THROTTLE));
    this.dh = dh;
    this.storageService = storageService;
    this.root = root;
  }
  removeRoot(filename) {
    return FileUtils.removeRoot(this.root, filename);
  }
  addRoot(path) {
    return FileUtils.addRoot(this.root, path);
  }
  createDirectory(path) {
    var _this = this;
    return _asyncToGenerator(function* () {
      yield _this.storageService.createDirectory(_this.addRoot(path));
      _this.refreshTables();
      return {
        type: 'directory',
        id: path,
        filename: path,
        basename: FileUtils.getBaseName(path)
      };
    })();
  }
  getTable() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var table = new GrpcFileStorageTable(_this2.storageService, _this2.root);
      _this2.tables.push(table);
      return table;
    })();
  }
  saveFile(file) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var fileContents = _this3.dh.storage.FileContents.text(file.content);
      yield _this3.storageService.saveFile(_this3.addRoot(file.filename), fileContents, true);
      _this3.refreshTables();
      return file;
    })();
  }
  loadFile(name) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var fileContents = yield _this4.storageService.loadFile(_this4.addRoot(name));
      var content = yield fileContents.text();
      return {
        filename: name,
        basename: FileUtils.getBaseName(name),
        content
      };
    })();
  }
  copyFile(name, newName) {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      var fileContents = yield _this5.storageService.loadFile(_this5.addRoot(name));
      yield _this5.storageService.saveFile(_this5.addRoot(newName), fileContents, false);
      _this5.refreshTables();
    })();
  }
  deleteFile(name) {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      yield _this6.storageService.deleteItem(_this6.addRoot(name));
      _this6.refreshTables();
    })();
  }
  moveFile(name, newName) {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      yield _this7.storageService.moveItem(_this7.addRoot(name), _this7.addRoot(newName));
      _this7.refreshTables();
    })();
  }
  info(name) {
    var _this8 = this;
    return _asyncToGenerator(function* () {
      var allItems = yield _this8.storageService.listItems(_this8.addRoot(FileUtils.getPath(name)), FileUtils.getBaseName(name));
      if (allItems.length === 0) {
        throw new FileNotFoundError();
      }
      if (allItems.length > 1) {
        log.error('More than one matching file found, should never happen.', allItems);
        throw new Error('More than one matching file found');
      }
      var itemDetails = allItems[0];
      if (!isFileType(itemDetails.type)) {
        throw new Error("Unexpected file type: ".concat(itemDetails.type));
      }
      return {
        filename: _this8.removeRoot(itemDetails.filename),
        basename: itemDetails.basename,
        id: _this8.removeRoot(itemDetails.filename),
        type: itemDetails.type
      };
    })();
  }
}
_defineProperty(GrpcFileStorage, "REFRESH_THROTTLE", 150);
export default GrpcFileStorage;
//# sourceMappingURL=GrpcFileStorage.js.map